export class OrderInvalidPhoneError extends Error {
    constructor() {
        super('ERROR_INVALID_PHONE');
    }
}
